function getTimestampFromDateAndTime(date, timeStr) {
    if (!(date instanceof Date) || !timeStr) return NaN;
    const [hour, minute, period] = timeStr.split(/[\s:]+/);
    const hour24 =
        period === "PM" && +hour !== 12
            ? +hour + 12
            : period === "AM" && +hour === 12
                ? 0
                : +hour;
    return new Date(date).setHours(hour24, +minute, 0, 0);
}
export default getTimestampFromDateAndTime;
